<template>
    <div class="card">
        <div class="card-body">
            <div class="text-center mb-3">
                <i class="icon-user icon-2x text-slate-300 border-slate-300 border-3 rounded-round p-3 mb-3 mt-1"></i>
                <h5 class="mb-0">{{ $t('auth.registration.title') }}</h5>
                <span class="d-block text-muted">{{ $t('auth.registration.create_user_description') }}</span>
            </div>

            <form @submit.prevent="storeUser">
                <FormGroup :label="$t('auth.fields.full_name')" required>
                    <Input :placeholder="$t('auth.fields.full_name')" v-model="fullName"/>
                </FormGroup>

                <FormGroup :label="$t('auth.fields.phone')" required>
                    <PhoneInput v-model="phone"/>
                </FormGroup>

                <FormGroup :label="$t('auth.fields.password')" required>
                    <Input type="password" :placeholder="$t('auth.fields.password')" v-model="password"/>
                </FormGroup>

                <FormGroup :label="$t('auth.fields.password_confirmation')" required>
                    <Input type="password" :placeholder="$t('auth.fields.password_confirmation')" v-model="passwordConfirmation"/>
                </FormGroup>

                <div style="display: flex">
                    <Button size="sm" @click="$emit('back')" color="secondary" class="mr-1" style="flex: 2">
                        <i class="icon-circle-left2 mr-2"></i>
                        {{ $t('auth.buttons.back') }}
                    </Button>
                    <Button size="sm" type="submit" color="primary" class="ml-1" style="flex: 3">
                        {{ $t('auth.buttons.send') }}
                        <i class="icon-circle-right2 ml-2"></i>
                    </Button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import PhoneInput from "../../../../../components/new/form/PhoneInput.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "CreateUserCard",
    components: {
        FormGroup,
        Input,
        PhoneInput,
        Button,
    },
    props: ['email', 'code'],
    emits: ['user-created', 'back'],
    data() {
        return {
            fullName: '',
            phone: '',
            password: null,
            passwordConfirmation: null,
        }
    },
    methods: {
        async storeUser() {
            await httpClient.post('/registration/store-user', {
                full_name: this.fullName,
                email: this.email,
                phone: this.phone,
                password: this.password,
                password_confirmation: this.passwordConfirmation,
                code: this.code,
                fs_lead_id: this.$route.query.fs_lead_id ?? null,
            });

            new MessageNotificator().success(this.$t('auth.registration.create_user_success'));
            this.$emit('user-created');
        },
    },
}
</script>
